<template>
 <div class="control app-inner">
    <div class="dashboard_container">
        <div class="dashboard-head boxs flex align-cen">
            <div class="head-left">
                <img :src="timeType == 1 ? require('../../assets/images/moring.png') : require('../../assets/images/icon05.png')" alt="">
            <span class="courtesy">{{timePeriod}}，{{userInfo.name}}</span>
            </div>
            <div class="mft flex align-cen">
                <div class="examingNumber">
                    <div class="title">开通仿真系统</div>
                    <div class="num">{{BasicInfo.appNum}}</div>
                </div>
                 <div class="expireNum">
                    <div class="title">即将过期的仿真系统服务</div>
                    <div class="num">{{BasicInfo.expireNum}}</div>
                 </div>
            </div>
        </div>
        <div class="dashboard-content">
            <div class="dashboard-content-left flex">
            <div class="dashboard-content-now boxs">
           <div class="public-tit flex align-cen" ref="document">
                <div class="public-tit-list">
                    <i class="icon-al-file"></i>  正在进行的试卷考试
                </div>
            </div>
            <div class="summaryOfTestLine">
                <div class="exam-pr-line">
                <div class="topBox flex">
                    <div class="examingNumber">
                        <div class="title">正在考试人数</div>
                        <div class="num">{{BasicInfo.examNum}}</div>
                    </div>
                      <div class="examingNumber">
                        <div class="title">正在考试试卷</div>
                        <div class="num">{{BasicInfo.examPaperNum}}</div>
                    </div>
                </div>
                 <div class="section-title">
                          今日考试情况
                        </div>
                <lineChart :option="LineChartOption" :barID="'lineID'"></lineChart>
            </div>
            </div>
            </div>
               <div class="dashboard-content-now boxs">
           <div class="public-tit flex align-cen" ref="document">
                <div class="public-tit-list">
                    <i class="icon-al-file"></i>  正在进行的仿真考试
                </div>
            </div>
            <div class="summaryOfTestLine">
                <div class="exam-pr-line">
                <div class="topBox flex">
                    <div class="examingNumber">
                        <div class="title">正在考试人数</div>
                        <div class="num">{{BasicInfo.assessNum}}</div>
                    </div>
                      <div class="examingNumber">
                        <div class="title">正在仿真考试</div>
                        <div class="num">{{BasicInfo.emuPaperNum}}</div>
                    </div>
                </div>
                 <div class="section-title">
                          今日考试情况
                        </div>
                <lineChart :option="LineChartOption2" :barID="'lineID2'"></lineChart>
            </div>
            </div>
            </div>
            </div>
            <div class="dashboard-info boxs flex align-cen">
                 <div class="examingNumber">
                        <div class="title">总试卷数</div>
                        <div class="num">{{BasicInfo.paperTotal}}</div>
                    </div>
                     <div class="examingNumber">
                        <div class="title">总试题数</div>
                        <div class="num">{{BasicInfo.questionTotal}}</div>
                    </div>
                    <div class="examingNumber">
                        <div class="title">总仿真试卷数</div>
                        <div class="num">{{BasicInfo.emuPaperTotal}}</div>
                    </div>
                     <div class="examingNumber">
                        <div class="title">总学员数</div>
                        <div class="num">{{BasicInfo.traineeNum}}</div>
                    </div>
                     <div class="examingNumber">
                        <div class="title">总教师数</div>
                        <div class="num">{{BasicInfo.teacherTotal}}</div>
                    </div>
            </div>
            <div class="quickOperate boxs">
                 <div class="section-title" style="margin:12px 0">
                          快捷操作
                        </div>
                <div class="oprateBox flex align-cen">
                    <div class="createExam createExam1" @click="openPublic('addEnTestPaper')">
                        <div class="quickContainer"  >
                            <img src="../../assets/images/ex1.png" alt="" class="oprateImg">
                            <div class="oprateText">创建试卷</div>
                        </div>
                    </div>
                    <div class="createExam createExam2" @click="openPublic('addQuestion')">
                        <div class="quickContainer">
                            <img src="../../assets/images/ex2.png" alt="" class="oprateImg">
                            <div class="oprateText">创建试题</div>
                        </div>
                    </div> 
                    <div class="createExam createExam1" @click="openPublic('member')">
                        <div class="quickContainer">
                            <img src="../../assets/images/ex4.png" alt="" class="oprateImg">
                            <div class="oprateText">成员列表</div>
                        </div>
                    </div>
                    <div class="createExam createExam3" @click="openPublic('studentList')">
                        <div class="quickContainer">
                            <img src="../../assets/images/ex3.png" alt="" class="oprateImg">
                            <div class="oprateText">学员列表</div>
                        </div>
                    </div>
                     <div class="createExam createExam2" @click="openPublic('questionImport')">
                        <div class="quickContainer" >
                            <img src="../../assets/images/ex5.png" alt="" class="oprateImg">
                            <div class="oprateText">导入试题</div>
                        </div>
                    </div>
                      <div class="createExam createExam1" @click="openPublic('enSimulationPaper')">
                        <div class="quickContainer"  >
                            <img src="../../assets/images/ex1.png" alt="" class="oprateImg">
                            <div class="oprateText">创建仿真试卷</div>
                        </div>
                    </div>
                </div>
            </div>
                       <div class="staff_manage_center boxs">
                   <div class="section-title" style="margin:12px 0">
                          正在进行的试卷考试
                        </div>
                 <div class="businessList-container-table">
                            <el-table
                ref="multipleTable"
                :data="examingList"
                tooltip-effect="dark"
                style="width: 100%"
                id='mytable'
                :header-cell-style="{background:'#eeeeee',color:'#666',paddingBottom:'10px'}"
                >
                     <el-table-column  label="试卷封面" align="center">
                        <template slot-scope="scope">
                            <img :src="scope.row.logo" alt="" style="width:100px;height:50px">
                        </template>
                 </el-table-column>
                 <el-table-column prop="paperName" label="试卷名称" align="center">
                 </el-table-column>
                  <el-table-column prop="classifyName" label="试卷分类" align="center">
                 </el-table-column>
                  <el-table-column prop="examNum" label="考试人次" align="center">
                 </el-table-column>
                  <el-table-column prop="unExamNum" label="未完成人数" align="center">
                 </el-table-column>
                  <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    width="150"          
                    >
                    <template slot-scope="scope">
                      <el-button type="text" style="color:red"  @click.stop="openmoniToring(scope.row)">考试监控</el-button> 
                     </template>
                   </el-table-column>
             </el-table>
                 </div>
                    <div class="section-title" style="margin:12px 0">
                          正在进行的仿真考试
                        </div>
                       <div class="businessList-container-table">
                            <el-table
                ref="multipleTable1"
                :data="examingList1"
                tooltip-effect="dark"
                style="width: 100%"
                id='mytable'
                :header-cell-style="{background:'#eeeeee',color:'#666',paddingBottom:'10px'}"
                >
                     <el-table-column  label="试卷封面" align="center">
                        <template slot-scope="scope">
                            <img :src="scope.row.logo" alt="" style="width:100px;height:50px">
                        </template>
                 </el-table-column>
                 <el-table-column prop="paperName" label="仿真试卷名称" align="center">
                 </el-table-column>
                  <el-table-column prop="appName" label="关联仿真应用" align="center">
                 </el-table-column>
                  <el-table-column prop="examNum" label="考试人次" align="center">
                 </el-table-column>
                  <el-table-column prop="unExamNum" label="未完成人数" align="center">
                 </el-table-column>
                  <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    width="150"          
                    >
                    <template slot-scope="scope">
                      <el-button type="text" style="color:red"@click.stop="openmoniToring1(scope.row)" >考试监控</el-button> 
                     </template>
                   </el-table-column>
             </el-table>
                 </div>
              </div>
                   <div class="summaryOfTestLine boxs">
                <div class="exam-pr-line exam-pr-line1">
                 <div class="section-title">
                          试卷考试次数变化
                        </div>
                <lineChart :option="LineChartOption1" :barID="'lineID1'"></lineChart>
            </div>
            </div>
                  <div class="summaryOfTestLine boxs">
                <div class="exam-pr-line exam-pr-line1">
                 <div class="section-title">
                          仿真考试次数变化
                        </div>
                <lineChart :option="LineChartOption3" :barID="'lineID3'"></lineChart>
            </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import { examControlInfo,listTodayResult,fzListTodayResult,listOngoingPaper,fzListOngoingPaper,listResult,fzListResult} from "@/api/enterprise/index"; // 控制中心基础信息、正在考试情况、仿真考试情况、试卷列表、仿真列表、试卷考试次数变化、仿真试卷考试次数变化
import lineChart from "@/components/lineTemolate/index.vue"; //柱状图图组件
export default {
       components:{
      lineChart,
    },
    data () {
        return {
            businessInfo:{},
            timePeriod:'',
            timeType:'',
            userInfo:{},
            BasicInfo:{},
            TodayResult:{},
            TodayResult1:{},
            LineChartOption:{},
            LineChartOption1:{},
            LineChartOption2:{},
             LineChartOption3:{},
            examingList:[],
            examingList1:[]
        }
    },
    created () {
        // document.title = 'HeroSim教师管理端-控制中心'
        this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
         this.userInfo = this.$locaStorage.setAge().get('userinfo1')
        this.getExamControlInfo()
        this.getlistTodayResult()
        this.getlistTodayResult1()
        this.getListOngoingPaper()
        this.getListOngoingPaper1()
        this.getListResult()
        this.getListResult1()
        this.getTimePeriod()
    },
    methods: {
        
          // 打开考试监控
      openmoniToring(data){
        this.$router.push({
            name: "enMoniToring",
            query:{
                id:data.paperId,
            }
           })
      },
          // 打开考试监控
      openmoniToring1(data){
        this.$router.push({
            name: "enRasoMoniToring",
            query:{
                id:data.paperId,
                type:2
            }
           })
      },
           // 打开对应页面
      openPublic(url){
       this.$router.push({name:url,query:{type:url=='addQuestion' ? 1 : 'dashboard'}})
      },  
      getTimePeriod() {  
      const currentTime = new Date();  
      const hours = currentTime.getHours();  
        
      if (hours >= 5 && hours < 12) {  
        this.timePeriod = '早安';  
        this.timeType = 1
      } else if (hours >= 12 && hours < 15) {  
        this.timePeriod = '中午好'; 
        this.timeType = 1
      } else if (hours >= 15 && hours < 18) {  
        this.timePeriod = '下午好';  
        this.timeType = 1
      }else if (hours >= 18 && hours < 22) {  
        this.timePeriod = '晚上好'; 
        this.timeType = 2 
      } else {  
        this.timePeriod = '夜深了，注意休息';  
        this.timeType = 2
      }  
    },
    // 获取考试次数变化
    getListResult(){
         listResult({businessId:this.businessInfo.id},'enterprise').then(res => {
                       let xData1 = [],
                   sData1 = []
               for (const key in res.data) {
                xData1.push(res.data[key].time)
                sData1.push(res.data[key].num)
               }
               this.LineChartOption1 = {
                 tooltip: {
                    trigger: 'axis',
                    formatter:function(params){
                    var str = '';
                     str = `${params[0].data}个考生在${params[0].name}号这一天考试了`
                     return str
                  }
                },
                  grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                 xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: xData1
                },
                  yAxis: {
                    type: 'value'
                },
                color:['#ff962a'],
                 series: [
                    {
                    data: sData1,
                    type: 'line',
                    emphasis: {
                        focus: 'series'
                    },
                    areaStyle: {},
                    }
                ]
               }
        })
    },
     // 获取仿真考试次数变化
    getListResult1(){
         fzListResult({businessId:this.businessInfo.id},'enterprise').then(res => {
                       let xData1 = [],
                   sData1 = []
               for (const key in res.data) {
                xData1.push(res.data[key].time)
                sData1.push(res.data[key].num)
               }
               this.LineChartOption3 = {
                 tooltip: {
                    trigger: 'axis',
                    formatter:function(params){
                    var str = '';
                     str = `${params[0].data}个考生在${params[0].name}号这一天考试了`
                     return str
                  }
                },
                  grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                 xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: xData1
                },
                  yAxis: {
                    type: 'value'
                },
                color:['#ff962a'],
                 series: [
                    {
                    data: sData1,
                    type: 'line',
                    emphasis: {
                        focus: 'series'
                    },
                    areaStyle: {},
                    }
                ]
               }
        })
    },
    // 获取试卷列表
    getListOngoingPaper(){
        listOngoingPaper({businessId:this.businessInfo.id},'enterprise').then(res => {
           this.examingList = res.data
        })
    },
     // 获取仿真试卷列表
    getListOngoingPaper1(){
        fzListOngoingPaper({businessId:this.businessInfo.id},'enterprise').then(res => {
           this.examingList1 = res.data
        })
    },
    // 获取控制中心基础情况
        getExamControlInfo(){
            examControlInfo({businessId:this.businessInfo.id},'enterprise').then(res => {
               this.BasicInfo = res.data
            })
        },
        // 今日考试情况
         getlistTodayResult(){
            listTodayResult({businessId:this.businessInfo.id},'enterprise').then(res => {
               this.TodayResult = res.data
               let xData = [],
                   sData = []
               for (const key in res.data) {
                xData.push(res.data[key].time)
                sData.push(res.data[key].num)
               }
               this.LineChartOption = {
                 tooltip: {
                    trigger: 'axis',
                    formatter:function(params){
                    var str = '';
                     str = `${params[0].name}</br>考试人数：${params[0].data}`
                     return str
                  }
                },
                  grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                 xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: xData
                },
                  yAxis: {
                    type: 'value'
                },
                color:['#36aafd'],
                 series: [
                    {
                    data: sData,
                    type: 'line',
                    emphasis: {
                        focus: 'series'
                    },
                    areaStyle: {},
                    }
                ]
               }
            })
        },
         // 今日仿真考试情况
         getlistTodayResult1(){
            fzListTodayResult({businessId:this.businessInfo.id},'enterprise').then(res => {
               this.TodayResult1 = res.data
               let xData = [],
                   sData = []
               for (const key in res.data) {
                xData.push(res.data[key].time)
                sData.push(res.data[key].num)
               }
               this.LineChartOption2 = {
                 tooltip: {
                    trigger: 'axis',
                    formatter:function(params){
                    var str = '';
                     str = `${params[0].name}</br>考试人数：${params[0].data}`
                     return str
                  }
                },
                  grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                 xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: xData
                },
                  yAxis: {
                    type: 'value'
                },
                color:['#36aafd'],
                 series: [
                    {
                    data: sData,
                    type: 'line',
                    emphasis: {
                        focus: 'series'
                    },
                    areaStyle: {},
                    }
                ]
               }
            })
        },
    }
}
</script>
<style lang="scss" scoped>
                .examingNumber{
            text-align: center;
            margin-right: 30px;
                    .title{
                font-size: 16px;
                 color: #999999;
            }
            .num{
                font-size: 40px;
                color: #36aafd;
                font-weight: normal;
                margin: 8px 0 0 0;
            }
                }
.section-title{
  margin-top: 25px;
  font-size: 16px;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #333333;
    font-weight: 700;
    text-indent: 16px;
    position: relative;
}
.section-title::before{
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 4px;
    height: 16px;
    background-color: #409eff;
    border-radius: 2px;
}
.control{
    margin-bottom: 70px;
    .dashboard_container{
    margin: 0 auto;
    .boxs{
        box-shadow: 0 0 7px 0 rgba(197, 197, 197, .5);
        border-radius: 3px;
                background: #fff;
        padding: 10px 20px;
        margin-top: 10px;
    }
    .dashboard-head{
        img{
            width: 38px;
            height: 38px;
        }
        .courtesy{
            font-size: 20px;
            margin-left: 20px;
        }
        .examingNumber,.expireNum{
            text-align: center;
            margin-right: 30px;
            .title{
                font-size: 16px;
                 color: #999999;
            }
            .num{
                font-size: 40px;
                color: #36aafd;
                font-weight: normal;
                margin: 8px 0 0 0;
            }
        }
    }
    .dashboard-content-now{
        margin-top: 10px;
        width: 50%;
         .summaryOfTestLine{
          margin-top:10px;
          .exam-pr-line{
            height: 550px;
            padding: 20px;
            border: 1px solid #e6e6e6;
            border-radius: 10px;
          }
          .exam-pr-line1{
            height: 400px !important;
          }
        }
    }
    .dashboard-info {
        justify-content: space-around;
    }
    .quickOperate{
        .oprateTitle{
            font-size: 20px;
            color: #333333;
            margin: 12px 0 12px 0;
        }
        .oprateBox{
            justify-content: center;
            .createExam{
                position: relative;
                background-color: #ffffff;
                border-radius: 4px !important;
                border: solid 1px #eeeeee;
                width: 200px;
                padding: 10px 15px;
                margin: 0 22px 16px 0;
                cursor: pointer;
                text-decoration: none;
                .oprateImg, .oprateText{
                    display: inline-block;
                    vertical-align: middle;
                    margin-left: 10px;
                }
                .oprateImg{
                    max-width: 47px;
                    word-break: keep-all;
                }
                .oprateText{
                    font-size: 15px;
                    font-weight: normal;
                    color: #000000;

                }
            }
            .createExam::before, .createExam::after{
                    width: 100%;
                    height: 100%;
                    z-index: 3;
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    box-sizing: border-box;
                    transform: scale(0);
                    -webkit-transition: 0.5s;
                    transition: 0.5s;
                    -webkit-border-radius: 4px;
                    -moz-border-radius: 4px;
                    border-radius: 4px;
            }
            .createExam:hover{
                border: 1px solid rgba(0, 160, 80, 0);
            }
            .createExam1::before{
                border-bottom: 1px solid #36aafd;
                border-left: 1px solid #36aafd;
                transform-origin: 0 100%;
            }
             .createExam1::after{
                border-top: 1px solid #36aafd;
                border-right: 1px solid #36aafd;
                transform-origin: 100% 0;
            }
            .createExam2::before{
                border-bottom: 1px solid #ff962a;
                border-left: 1px solid #ff962a;
                transform-origin: 0 100%;
            }
             .createExam2::after{
                border-top: 1px solid #ff962a;
                border-right: 1px solid #ff962a;
                transform-origin: 100% 0;
            }
            .createExam3::before{
                border-bottom: 1px solid #d52b2a;
                border-left: 1px solid #d52b2a;
                transform-origin: 0 100%;
            }
             .createExam3::after{
                border-top: 1px solid #d52b2a;
                border-right: 1px solid #d52b2a;
                transform-origin: 100% 0;
            }
            .createExam:hover::after,.createExam:hover::before{
                transform: scale(1);
            }
        }
    }
    }
}
</style>